<template>
  <div class="event-card">
    <nuxt-link v-if="mainImage" class="event-card-image" :style="mainImage" />

    <div class="event-card-data my-10">
      <div v-if="date" class="event-card-date">
        <span>{{ date }}</span>
      </div>

      <h6 class="mt-5 mb-10 text-h2">
        {{ source.title  }}
      </h6>

      <div class="event-card-data-text">
        <span v-html="text" />
      </div>
    </div>

    <div class="event-card-more">
      <nuxt-link v-if="event.href" class="mt-5" :to="more">
        Подробнее
      </nuxt-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import {PropType} from 'vue';
import {EventRecord, PersonalOffer} from '~/types/components/personal/actions';
import {formatDate} from '~/common/date';

const props = defineProps({
  event: {
    type: Object as PropType<EventRecord>,
    default: () => ({})
  },
  offer: {
    type: Object as PropType<PersonalOffer>,
    default: () => ({})
  }
})

const source = computed((): PersonalOffer|EventRecord => {
  return props.offer?.guid ? props.offer : props.event
})

const mainImage = computed(() => {
  const url = props.event.img || props.offer.imageUrl
  return url ? { backgroundImage: `url('${url}')` } : null
})

const text = computed(() => {
  return source.value.announce || props.event.content
})

const date = computed(() => {
  return props.event.date ? formatDate(props.event.date) : ''
})

const more = computed((): any => {
  if (!props.event.href) {
    return ''
  }
  return props.event.href
    ? { name: 'news-id', params: { tag: props.event.isAction ? 'actions' : 'news', id: props.event.href } }
    : ''
})
</script>

<style lang="scss" scoped>
.event-card {
  display: flex;
  flex-direction: column;
  background-color: $white;
  padding: 20px;
  border-radius: 6px;

  &-image {
    height: 150px;
    background-position: center;
    border-radius: 6px;
    background-size: cover;

    &-sm {
      display: none;
    }
  }

  &-date {
    color: $font-light;
    font-size: $fs-12;
  }

  &-data {
    &-text {
      font-size: $fs-14;

      li {
        margin-left: 14px;
      }
    }
  }

  &-more {
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
    font-size: $fs-14;
    color: $primary;
    cursor: pointer;
    &:hover {
      color: $primary;
    }
  }
}
</style>
